import React, { useEffect } from "react";
import { toast } from 'react-toastify';
import { useHistory } from "react-router-dom"

const Redirection = ({message, path}) => {
    const history = useHistory()

    useEffect(() => {
        history.push(path); // Navigate to /new-path
        toast.error(`${message}`);
    }, [])

    return(
        <>
        </>
    )
}

export default Redirection;